
import DniForm from "./dniForm"
import QrWalletPayment from "./qrWalletPayment"
import React, { useCallback, useState } from "react";
import PendingList from "./pendingList";
import RefundPayment from "./refundPayment";
import BalancePayment from "./balancePayment";
import CardGeneric from "../../../components/common/CardGeneric";
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import styled from "styled-components";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ButtonTransparent } from "../../../components/common/ButtonsGenerics";
import usePaymentWatchdog from "../../../hooks/usePaymentWatchdog";
import { sisadEstadoPagoEnum } from "../../../redux/types/payment";


const DirectPaymentProcess = () => {

    //Estados
    const [user, setUser] = useState("")
    const [page, setPage] = useState(0)
    const [total, setTotal] = useState(null)
    const [idClient, setIdClient] = useState(null)
    const [selectedRequestIds, setSelectedRequestIds] = useState([])
    const [paymentOk, setPaymentOk] = useState(false)
    const [qrString, setQrString] = useState(null)
    
    //constantes
    const urlPay = `${process.env.REACT_APP_RQUEST_PAY}&import=${total}&client_ref=${idClient}`
    const MS_TO_DISPLAY_SUCCESS_MSA = 8000;

    // Callbacks memoizados
    const handleQrSuccess = useCallback(() => {
        setPaymentOk(true);
        setTimeout(() => {
            setPage(null);
        }, MS_TO_DISPLAY_SUCCESS_MSA);
    }, [MS_TO_DISPLAY_SUCCESS_MSA]);

    // Watchdog centralizado - controla ambos flujos de pago
    usePaymentWatchdog(page, idClient, setPage, {
        paymentConfig: {
            'iframe': {
                pollingTime: 2000,
                maxAttempts: 200,
                shouldExit: (status) => status !== sisadEstadoPagoEnum.EN_PROCESO,
                isSuccess: (status) => status === sisadEstadoPagoEnum.PAGADO,
                onSuccess: () => { }
            },
            'qrWalletPayment': {
                pollingTime: 2000,
                maxAttempts: 30,
                shouldExit: (status) => status !== sisadEstadoPagoEnum.EN_PROCESO,
                isSuccess: (status) => status === sisadEstadoPagoEnum.PAGADO,
                onSuccess: handleQrSuccess
            }
        }
    });

    //Funciones
    const handleGoToPage = (page) => {
        setPage(page)
        //setUser(null);
    }

    const handlePagePay = (total, id, method, selectedRequestIds = []) => {

        setTotal(total)
        setIdClient(id)
        setSelectedRequestIds(selectedRequestIds)

        if (method === 'generate-refund') {
            setPage('generateRefund')
        }
        if (method === 'balance-payment') {
            setPage('balancePayment')
        }
        if (method === 'credit-card') {
            setPage('iframe')
        }
        if (method === 'qr-wallet') {
            setPage('qrWalletPayment')
        }
    }

    // Returns

    if (page === 'pendigRequests') {
        return <PendingList user={user} handlePagePay={handlePagePay} gotoPage={handleGoToPage} />
    }

    if (page === 'generateRefund') {
        return <CurrentWrapper>
            <ArrowBackContainer>
                <ButtonTransparent onClick={() => handleGoToPage('pendigRequests')}><ArrowBackIcon /><NameButton>Atras</NameButton></ButtonTransparent>
            </ArrowBackContainer>
            <CardGeneric title={"Generar reintegro"} icon={<AssignmentReturnIcon />}>
                <RefundPayment amount={total} gotoPage={handleGoToPage} selectedRequestIds={selectedRequestIds} />
            </CardGeneric>
        </CurrentWrapper>
    }

    if (page === 'balancePayment') {
        return <CurrentWrapper>
            <ArrowBackContainer>
                <ButtonTransparent onClick={() => handleGoToPage('pendigRequests')}><ArrowBackIcon /><NameButton>Atras</NameButton></ButtonTransparent>
            </ArrowBackContainer>
            <CardGeneric title={"Pagar con saldo"} icon={<AccountBalanceWalletIcon />}>
                <BalancePayment gotoPage={handleGoToPage} selectedRequestIds={selectedRequestIds} />
            </CardGeneric>
        </CurrentWrapper>
    }

    if (page === 'iframe') {
        return <CurrentWrapper>
            <ArrowBackContainer>
                <ButtonTransparent onClick={()=>handleGoToPage(null)}><ArrowBackIcon /><NameButton>Atras</NameButton></ButtonTransparent>
            </ArrowBackContainer>
            <CardGeneric title={"Datos de pago"} icon={<AccountBalanceWalletIcon />}>
                <Iframe src={urlPay} />
            </CardGeneric>
        </CurrentWrapper>
    }

    if (page === 'qrWalletPayment') {
        return <CurrentWrapper>
            <ArrowBackContainer>
                <ButtonTransparent onClick={()=>handleGoToPage(null)}><ArrowBackIcon /><NameButton>Atras</NameButton></ButtonTransparent>
            </ArrowBackContainer>
            <CardGeneric title={"Pago con Qr"} icon={<AccountBalanceWalletIcon />}>
                <QrWalletPayment
                    amount={total}
                    clientId={idClient}
                    gotoPage={handleGoToPage}
                    setQrString={setQrString}
                    qrString={qrString}
                    paymentOk={paymentOk}
                    setPaymentOk={setPaymentOk}
                />
            </CardGeneric>
        </CurrentWrapper>
    }

    
    return <DniForm
        user={user}
        setUser={setUser}
        handleDniSubmit={handleGoToPage} />

}

export default DirectPaymentProcess

const CurrentWrapper = styled.div`
width: 100%;
`

const ArrowBackContainer = styled.div`
    width: 100%;
    height: 6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const NameButton = styled.div`
    margin-left: 1rem;
    font-size: 1rem;
`

const Iframe = styled.iframe`
    width: 600px;
    height: 600px;
    border: none;
`

